import {
  Component,
  TemplateRef,
  ViewChild,
  ElementRef,
  forwardRef,
  EventEmitter,
  Output
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { MultiViewCalendarComponent } from '@progress/kendo-angular-dateinputs';
import { firstDayOfMonth, lastDayOfMonth } from '@progress/kendo-date-math';

export function outerWidth(element: any): number {
  let width = element.offsetWidth;
  const style = getComputedStyle(element);
  width += parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0;
  return width;
}

@Component({
  providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => SelectPayperiodComponent) }],
  selector: 'app-select-payperiod',
  templateUrl: './select-payperiod.component.html',
  styleUrls: ['./select-payperiod.component.scss']
})
export class SelectPayperiodComponent extends ToolBarToolComponent {

  @Output() valueChange = new EventEmitter();
  @Output() search = new EventEmitter();

  @ViewChild('toolbarTemplate', { static: true }) public toolbarTemplate: TemplateRef<any>;
  @ViewChild('toolbarElement', { static: false }) public toolbarElement: ElementRef;

  @ViewChild('calendar', { read: MultiViewCalendarComponent, static: false }) public calendar: MultiViewCalendarComponent;
  @ViewChild('button', { static: false }) public button: ElementRef;

  public tabindex = -1;

  public toggleText = 'Show';
  public show = false;
  public range: { start: Date; end: Date };
  public opened: boolean;

  constructor() {
      super();
      this.range = this.getRange(new Date());
      this.opened = false;
  }

  valueChanged(value: Date) {
    this.range = this.getRange(value);
    this.valueChange.emit(this.range);
  }

  getRangeLabel() {
    const opts = {day: 'numeric', month: 'short', year: 'numeric'};
    return `${this.range.start.toLocaleString('en-US', opts)} - ${this.range.end.toLocaleString('en-US', opts)}`;
  }

  open() {
    this.opened = true;
  }

  done() {
    this.close();
    this.search.emit();
  }

  close() {
    this.opened = false;
  }

  getRange(value: Date) {
    let start = value;
    let end = value;
    if (value.getDate() <= 15) {
      start = firstDayOfMonth(value);
      end.setDate(15);
    } else {
      start.setDate(16);
      start.setMonth(value.getMonth());
      end = lastDayOfMonth(value);
    }
    return {start, end};
  }

  public get outerWidth(): number {
      if (this.toolbarElement) {
          return outerWidth(this.toolbarElement.nativeElement);
      }
  }

  public canFocus(): boolean {
      return true; // marks the tools as focusable
  }

  public focus(): void {
      // manage the roving tabindex
      // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
      this.tabindex = 0;
      if (this.overflows) {
          // focus the button in the overflowTemplate
          this.button.nativeElement.focus();
      }
  }

  public handleKey(): boolean {
      // manage the roving tabindex
      // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
      this.tabindex = -1;
      // tell the toolbar that the focus can move to the next/prev focusable tool
      return false;
  }
}
